import { ITrangThaiKhoSearchRequest } from "../../model/request/quan-ly-kho/ITrangThaiKhoSearchRequest";
import { apiClient } from "../apiClient";

export const UF_TRANGTHAIKHO_API_RESOURCE = "uf_trangthaikho";

export const ufTrangThaiKhoApi = {
    Select: (payload: ITrangThaiKhoSearchRequest) => apiClient.post(`${UF_TRANGTHAIKHO_API_RESOURCE}/select`, payload),
};
